<template>
    <span></span>
    <!--<google-pay-button-->
            <!--v-if="config.payment.googlePay.enabled"-->
                       <!--:environment="config.production? 'PRODUCTION' : 'TEST'"-->
                       <!--button-type="long"-->
                       <!--:button-color="this.buttonColor"-->
                       <!--v-bind:paymentRequest.prop="{-->
							<!--apiVersion: 2,-->
							<!--apiVersionMinor: 0,-->
							<!--allowedPaymentMethods: [-->
							  <!--{-->
								<!--type: 'CARD',-->
								<!--parameters: {-->
								  <!--allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],-->
								  <!--allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD', 'DISCOVER']-->
								<!--},-->
								<!--tokenizationSpecification: {-->
								  <!--type: 'PAYMENT_GATEWAY',-->
								  <!--parameters: {-->
									<!--'gateway': 'stripe',-->
									<!--'stripe:version': '2018-10-31',-->
									<!--'stripe:publishableKey': config.payment.googlePay.stripePublishableKey-->
								  <!--}-->
								<!--}-->
							  <!--}-->
							<!--],-->
							 <!--merchantInfo: {-->
							  <!--merchantName: 'GameEnable',-->
							  <!--merchantId: 'BCR2DN6T3POY56S4'-->
							<!--},-->
							<!--transactionInfo: {-->
							  <!--totalPriceStatus: 'FINAL',-->
							  <!--totalPriceLabel: 'Total',-->
							  <!--totalPrice: '4.99',-->
							  <!--currencyCode: 'USD',-->
							  <!--countryCode: 'US'-->
							<!--}-->
						  <!--}"-->
                       <!--v-on:loadpaymentdata="onLoadPaymentData"-->
                       <!--v-on:paymentAuthorized="onPaymentAuthorized"-->
    <!--&gt;</google-pay-button>-->
</template>

<script>
import config from '../config'
import '@google-pay/button-element'

  export default {
    props: {
        'button-color': {
            type: String,
            default: 'white'
        },
        'customer-email': {
            type: String
        }
    },
      data: ()=> ({
        config
    }),
    methods: {
        onPaymentAuthorized(){},
        async onLoadPaymentData(paymentData){


            var tokenStr = paymentData.detail.paymentMethodData.tokenizationData.token;
            try {
                var token = JSON.parse(tokenStr);
                console.log("Sending Payment Authorization token to the server: " + token.id);
                var bodyObj = {
                    'paymentToken' : token.id,
                    'paymentCardToken' : token.card.id,
                    'customerEmail': this.customerEmail
                };
                var bodyStr = JSON.stringify(bodyObj);
                const response = await fetch(`${config.serverURL}/charge`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: bodyStr }
                );


                var responseJSON = await response.json();
                this.$emit('loadpaymentdata', responseJSON);

            }
            catch (ex) {
                console.log("Failed receiving an approval for the payment", ex);
            }



        }
    }
  }


</script>
